module.exports = __webpack_public_path__ + "static/media/mono-black.b8e75602.svg";